<template>
<div>
  <div style="display: block;margin-top: 90px" >
    <img src="../../assets/images/blog.png"  width="100%" />
  </div>
  <iframe width="100%" height="800px" :src="html"></iframe>

</div>
</template>

<script>
export default {
  name: 'blog-detail',
  data () {
    return {
      html: 'static\\blog\\养肝最好的方式.html'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/blog/blog-detail.vue